import { render } from "./TagView.vue?vue&type=template&id=e75ec5de&scoped=true"
import script from "./TagView.vue?vue&type=script&lang=js"
export * from "./TagView.vue?vue&type=script&lang=js"

import "./TagView.vue?vue&type=style&index=0&id=e75ec5de&scoped=true&lang=css"

import exportComponent from "/Users/peterdevos/Sites/sephendevos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e75ec5de"]])

export default __exports__